import React from "react";
import { IInkAndTonerOption } from "./inkAndTonerDropdown";
import SelectYourXDropdown from "./selectYourXDropdown";

export interface ISelectYourXProps {
  openDropdownIndex: number;
  selectYourXDropdownIndex: number;
  buttonText: string;
  isDisabled?: boolean;
  value: string;
  setOpenDropdownIndex: (index: number) => void;
  filterPlaceholderText: string;
  arrayForSelection: IInkAndTonerOption[];
  callBack: (event: string) => void;
}

const ChevronBrightBlueDownImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/chevron-brightblue-down.png";

const ChevronBrightBlueUpImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/chevron-brightblue-up.png";

const ChevronWhiteDownImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/chevron-white-down.png";

const ChevronWhiteUpImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/chevron-white-up.png";

const Step1ActiveImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/step1-active.png";

const Step2ActiveImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/step2-active.png";

const Step2DisabledImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/step2-disabled.png";

const Step3ActiveImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/step3-active.png";

const Step3DisabledImg =
  process.env.PUBLIC_URL + "/images/inkAndToner/step3-disabled.png";

class SelectYourX extends React.Component<ISelectYourXProps> {
  render() {
    const isOpen =
      this.props.openDropdownIndex === this.props.selectYourXDropdownIndex;
    let btnImg = "",
      btnClass = "",
      btnChevron = "";
    let btnText = this.props.buttonText;
    if (!this.props.isDisabled && !this.props.value) {
      btnClass = "current-selection btn";
      switch (this.props.selectYourXDropdownIndex) {
        case 0:
          btnImg = Step1ActiveImg;
          break;
        case 1:
          btnImg = Step2ActiveImg;
          break;
        case 2:
          btnImg = Step3ActiveImg;
          break;
      }
      btnChevron = isOpen ? ChevronWhiteUpImg : ChevronWhiteDownImg;
    } else if (!this.props.isDisabled && this.props.value) {
      btnClass = "selected btn";
      btnImg =
        process.env.PUBLIC_URL + "/images/inkAndToner/blue-checkmark.png";
      btnChevron = isOpen ? ChevronBrightBlueUpImg : ChevronBrightBlueDownImg;
    } else {
      btnClass = "to-be-selected btn";
      switch (this.props.selectYourXDropdownIndex) {
        case 1:
          btnImg = Step2DisabledImg;
          break;
        case 2:
          btnImg = Step3DisabledImg;
          break;
      }
      btnChevron = isOpen ? ChevronBrightBlueUpImg : ChevronBrightBlueDownImg;
    }
    if (this.props.value) {
      btnText = decodeURIComponent(this.props.value);
    }
    return (
      <div className="select-your-x">
        <button
          disabled={this.props.isDisabled}
          className={btnClass}
          type="button"
          onClick={() => {
            this.props.setOpenDropdownIndex(
              isOpen ? -1 : this.props.selectYourXDropdownIndex
            );
          }}
        >
          <img src={btnImg} alt={btnText} className="vertical-align-middle" />
          <span className="selectText vertical-align-middle">{btnText}</span>
          <img
            src={btnChevron}
            className={"chevron vertical-align-middle"}
            alt={"open" + this.props.filterPlaceholderText}
          />
        </button>
        {isOpen ? (
          <SelectYourXDropdown
            arrayForSelection={this.props.arrayForSelection}
            selectYourXDropdownIndex={this.props.selectYourXDropdownIndex}
            callBack={(event: string) => {
              this.props.setOpenDropdownIndex(-1);
              this.props.callBack(event);
            }}
            filterPlaceholderText={this.props.filterPlaceholderText}
          />
        ) : null}
      </div>
    );
  }
}

export default SelectYourX;
